import React from 'react';

export default function IndexSectionHowItWorksDarkPattern10() {
    return (
        <React.Fragment>
            <>
                <section className="py-24 bg-coolGray-900 overflow-hidden" style={{backgroundImage: 'url("flex-ui-assets/elements/pattern-dark2.svg")', backgroundPosition: 'center'}}>
  <div className="container px-4 mx-auto">
    <div className="flex flex-wrap -mx-4">
      <div className="w-full md:w-1/2 px-4 mb-16 md:mb-0">
        <div className="relative mx-auto md:ml-0 max-w-max">
          <img className="absolute z-10 -right-8 -top-8 w-28 md:w-auto" src="flex-ui-assets/elements/circle3-yellow.svg" alt="Decorative circle element" />
          <img className="absolute z-10 -left-10 -bottom-8 w-28 md:w-auto" src="flex-ui-assets/elements/dots3-blue.svg" alt="Decorative dots element" />
          <img src="https://res.cloudinary.com/dgkoae5ks/image/upload/v1747714828/bagga-international/PTB-909.webp" alt="Bagga International Tool Belt Product" />
        </div>
      </div>
      <div className="w-full md:w-1/2 px-4">
        <h2 className="mb-12 text-4xl md:text-5xl leading-tight text-white font-bold tracking-tighter">Why Choose Bagga International?</h2>
        <div className="flex flex-wrap -mx-4 text-center md:text-left">
          <div className="w-full md:w-1/2 px-4 mb-8">
            <div className="inline-flex items-center justify-center mb-4 w-12 h-12 text-xl text-coolGray-900 bg-green-500 font-semibold rounded-full">1</div>
            <h3 className="mb-2 text-xl text-white font-bold">45 years of Industry Expertise</h3>
            <p className="font-medium text-coolGray-400">With four decades of experience, we craft durable, high-quality tool belts, tool bags, and accessories trusted by professionals worldwide.</p>
          </div>
          <div className="w-full md:w-1/2 px-4 mb-8">
            <div className="inline-flex items-center justify-center mb-4 w-12 h-12 text-xl text-coolGray-900 bg-green-500 font-semibold rounded-full">2</div>
            <h3 className="mb-2 text-xl text-white font-bold">Unmatched Quality &amp; Craftsmanship</h3>
            <p className="font-medium text-coolGray-400">Our products are designed for strength and reliability, using premium materials to withstand tough job site conditions.</p>
          </div>
          <div className="w-full md:w-1/2 px-4 mb-8">
            <div className="inline-flex items-center justify-center mb-4 w-12 h-12 text-xl text-coolGray-900 bg-green-500 font-semibold rounded-full">3</div>
            <h3 className="mb-2 text-xl text-white font-bold"> Wide Range of Products</h3>
            <p className="font-medium text-coolGray-400">From tool pouches and aprons to suspenders and saw cases, we offer solutions for every tradesperson’s needs.</p>
          </div>
          <div className="w-full md:w-1/2 px-4">
            <div className="inline-flex items-center justify-center mb-4 w-12 h-12 text-xl text-coolGray-900 bg-green-500 font-semibold rounded-full">4</div>
            <h3 className="mb-2 text-xl text-white font-bold">Trusted by Professionals</h3>
            <p className="font-medium text-coolGray-400">Carpenters, electricians, and construction workers rely on our tool storage solutions to keep their gear organized and accessible.</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>


            </>
        </React.Fragment>
    );
}

